import * as React from 'react';
import { NumericFormat } from 'react-number-format';
import TextField from '@mui/material/TextField';
import './InputNumber.scss';
import { produce } from 'immer';
import { cloneDeep } from 'lodash';
import { InputAdornment, useTheme } from '@mui/material';

type TextAlign = "center" | "justify" | "left" | "right" | "start"

type Props = {
    // value: string | number | undefined
    align?: TextAlign
    color?: string
    fullWidth?: boolean,

    realValue?: string | number
    handleChangeInput: (event: React.ChangeEvent<HTMLInputElement>) => void
    error?: boolean
    prefix?: string
    suffix?: string
    decimalScale?: number
    thousandSeparator?: '.' | ','
    // decimalSeparator?: '.' | ','
    minValue?: number, // min must less or equal 0 or value pass on parent == minValue
    maxValue?: number,
    endAdornment?: string
    startAdornment?: string
    allowNegative?: boolean
    disabled?: boolean
    id?: string
}

export default function InputNumber(props: Props) {
    const { align, color, fullWidth, realValue, handleChangeInput, error, prefix,
        decimalScale, suffix, thousandSeparator, //decimalSeparator
        minValue, maxValue, endAdornment, startAdornment, allowNegative, disabled, id,
    } = props

    const [valueMask, setValueMask] = React.useState(realValue)
    const refNoTouch = React.useRef<boolean>(true)
    const theme = useTheme()

    React.useEffect(() => {
        // console.log('ha_check_realValue', { refNoTouch, realValue })
        if (refNoTouch) {
            setValueMask(realValue)
        }
    }, [refNoTouch, realValue])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        refNoTouch.current = false
        setValueMask(event.target.value)
    };

    const MIN = React.useMemo(() => {
        return minValue === 0 ? 0 : minValue ? minValue : Number.MIN_SAFE_INTEGER
    }, [minValue])

    const MAX = React.useMemo(() => {
        return maxValue === 0 ? 0 : maxValue ? maxValue : Number.MAX_SAFE_INTEGER
    }, [maxValue])

    const slotPropsInput = React.useMemo(() => {
        let rawSlotPropsInput: any = {
            endAdornment: <InputAdornment position="start">{endAdornment}</InputAdornment>,
            startAdornment: <InputAdornment position="start">{startAdornment}</InputAdornment>,
        }
        if (endAdornment === undefined) {
            delete rawSlotPropsInput.endAdornment
        }
        if (startAdornment === undefined) {
            delete rawSlotPropsInput.startAdornment
        }
        return rawSlotPropsInput
    }, [endAdornment, startAdornment])



    return (
        <>
            <NumericFormat
                id={id}
                onValueChange={(values, sourceInfo) => {
                    console.log('ha_check_sourceInfo', { values, sourceInfo });
                    const cloneEvent = cloneDeep(sourceInfo.event) as React.ChangeEvent<HTMLInputElement>
                    const cloneTarget: any = cloneDeep(sourceInfo?.event?.target)
                    const updatedEvent = produce({ ...cloneEvent }, (draft: React.ChangeEvent<HTMLInputElement>) => {
                        if (draft && draft.target && cloneTarget) {
                            cloneTarget.value = values?.floatValue ?? '';
                            draft.target = cloneTarget// values?.floatValue?.toString() ?? '';
                            // draft.target.value =  values?.floatValue?.toString() ?? '';

                        }
                    }) as React.ChangeEvent<HTMLInputElement>;

                    if (updatedEvent && updatedEvent.target) {
                        handleChangeInput(updatedEvent);
                    }
                }}
                className='mf-number-input-format'
                value={valueMask}
                onChange={handleChange}
                customInput={TextField}
                thousandSeparator={thousandSeparator ?? ','}
                decimalSeparator={thousandSeparator === '.' ? ',' : '.'}
                // valueIsNumericString={false}
                decimalScale={decimalScale ?? 0}
                prefix={prefix}
                suffix={suffix}
                // variant="standard"
                sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, background: theme.palette.background.input, '& .MuiInputBase-input': { color: `${color ?? theme.palette.text.primary} !important` } }}
                slotProps={{
                    htmlInput: { sx: { textAlign: align ? align : 'start' } },
                    input: slotPropsInput,
                }}
                size={'small'}
                fullWidth={fullWidth ?? true}
                error={error}
                max={MAX}
                min={MIN}
                allowNegative={allowNegative ?? false}
                disabled={disabled}
                isAllowed={(values) => {
                    const { floatValue } = values;
                    if (floatValue === undefined) {
                        return true
                    }
                    return (floatValue >= MIN) && (floatValue <= MAX)
                }}
            />

        </>
    );
}

